'use client'

import React from 'react'
import { useSelector } from 'react-redux'
import EmptyCart from '@/entities/cart-page/EmptyCart'
import PlacingOrder from '@/widgets/PlacingOrder'
import CartOrders from '@/features/cart-page/CartOrders'
import { getDeclOfNum } from '@/shared/hooks/useGetDeclOfNum.js'
import { useGetIsAuthUser } from '@/shared/hooks/useGetIsAuthUser.js'
import { Helmet } from 'react-helmet'
import { useGetCartInfoQuery } from '@/shared/api-rtk/api-list/cartApi'
// import { API_URL, CDEK_WIDGET_PATH } from '@/shared/constants/linksApi'
// import { CdekWidget } from '@/features/cart-page/CdekWidget/ui/CdekWidget.jsx'

// const cdekScriptId = 'ISDEKscript'

export const CartPage = () => {
    const countItems = useSelector((state) => state.cartActions.countItems)
    const dynamicStringTitle = `${countItems} ${getDeclOfNum(countItems, [
        'товар',
        'товара',
        'товаров',
    ])}`
    let { data, refetch } = useGetCartInfoQuery()
    const { userInfo } = useGetIsAuthUser()

    const cert =
        data?.products &&
        data?.products?.some(function (item) {
            return item.name === 'Подарочный сертификат'
        })

    // const [cdekScriptLoaded, setCdekScriptLoaded] = useState(false)

    // useEffect(() => {
    //     const scriptList = document.querySelectorAll(
    //         "script[type='text/javascript']"
    //     )
    //     const convertedNodeList = Array.from(scriptList)
    //     console.log(convertedNodeList)
    //     const testScript = convertedNodeList.find(
    //         (script) => script.id === cdekScriptId
    //     )
    //     if (testScript) {
    //         setCdekScriptLoaded(true)
    //         return
    //     }
    //     const script = document.createElement('script')
    //     script.id = cdekScriptId
    //     script.src = CDEK_WIDGET_PATH
    //     script.type = 'text/javascript'
    //     script.async = true
    //     document.body.append(script)
    //     setCdekScriptLoaded(true)
    // }, [])

    // if (countItems === 0 || !cdekScriptLoaded) {
    //     return <EmptyCart />
    // }

    if (countItems === 0) {
        return <EmptyCart />
    }

    return (
        <div className={'CartPage'}>
            <Helmet>
                <title>Корзина</title>
            </Helmet>
            <h1>
                Ваша корзина, <span>{dynamicStringTitle}</span>
            </h1>
            <CartOrders
                data={data}
                refetch={refetch}
                cert={cert}
                userInfo={userInfo}
            />
            <PlacingOrder cert={cert} userInfo={userInfo} />
        </div>
    )
}
